<template>
<div class="search-wrap main-1">
  <p class="top">首页 &rsaquo; 搜索结果：{{ $route.query.keyword }}</p>
  <ul class="data-list" v-if="list && list.length">
    <li class="item clearfix" v-for="item of list" :key="item.id">
      <div class="left avatar">
        <nuxt-link :to="`/room/${item.id}`"><img :src="item.teacherAvatar" :alt="item.teacherName"></nuxt-link>
      </div>
      <div class="left info">
        <h4><nuxt-link :to="`/room/${item.id}`">{{ item.teacherName }}</nuxt-link> <span :class="{ 'status-0': item.lastTopicStatus === 11, 'status-1': item.lastTopicStatus === 12, 'status-2': item.lastTopicStatus === 21 }">直播中</span></h4>
        <p>{{ item.introduce }}</p>
      </div>
      <div class="right icon-list clearfix">
        <nuxt-link tag="p" :to="`/question/list/${item.teacherId}`" class="right wenda"><i class="iconfont icon-wenda"></i></nuxt-link>
        <nuxt-link tag="p" :to="`/vip/detail/${item.teacherId}`" class="right txb"><i class="iconfont icon-txb"></i></nuxt-link>
        <nuxt-link tag="p" :to="`/article/list/${item.teacherId}`" class="right cjg"><i class="iconfont icon-cjg"></i></nuxt-link>
        <nuxt-link tag="p" :to="`/room/${item.id}`" class="right zb"><i class="iconfont icon-zb"></i></nuxt-link>
      </div>
    </li>
  </ul>
  <ul class="data-list" v-else>
    <div class="error-tip">您搜索的老师不存在...</div>
  </ul>
</div>
</template>

<script>
export default {
  watchQuery: ['keyword'],
  async asyncData ({ query, redirect, $axios }) {
    if (!query.keyword) {
      redirect('/')
      return false
    }
    let { list } = await $axios._get('/Room/List', { keyword: query.keyword })

    return {
      list
    }
  },
  mounted () {
    if (this.$root.$el.clientHeight < window.innerHeight) {
      this.$root.$el.querySelector('.footer_wrap').classList.add('footer-fixed')
    }
  },
  beforeDestroy () {
    this.$root.$el.querySelector('.footer_wrap').classList.remove('footer-fixed')
  }
}
</script>

<style lang="less">
.footer-fixed {
  position: fixed; left: 0; bottom: 0; width: 100%; padding-right: 17px;
}
.search-wrap {
  padding: 40px 0;
  .top {
    color: #666; font-size: 14px;
  }
  .data-list {
    margin-top: 30px;
    .item {
      padding: 30px; border: 1px solid #eaeaea;
      &:not(:first-child) {
        margin-top: -1px;
      }
      .avatar {
        width: 90px;
        img {
          width: 80px; height: 80px; border-radius: 50%;
        }
      }
      .info {
        width: 600px;
        h4 {
          font-size: 16px;
          span {
            width: 55px; line-height: 20px; font-size: 12px; display: inline-block; text-align: center; color: #ffffff; border-radius: 10px; margin-left: 5px;
            &.status-0 {
              background-color: #ec434a;
            }
            &.status-1 {
              background-color: #cda26f;
            }
            &.status-2 {
              background-color: #666;
            }
          }
        }
        p {
          margin-top: 15px; font-size: 14px; height: 38px; overflow: hidden; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; color: #999999;
        }
      }
      .icon-list {
        width: 360px; margin-top: 25px; margin-right: 40px;
        p {
          width: 38px; height: 38px; margin-right: 30px; border-radius: 50%; border: 2px solid #000; text-align: center; transition: background-color .3s, color .3s; cursor: pointer;
          i {
            display: inline-block;
          }
          &.wenda {
            color: #9ccaff; border-color: #9ccaff;
            .iconfont {
              font-size: 28px; margin-top: 3px;
            }
            &:hover {
              background-color: #9ccaff; color: #ffffff;
            }
          }
          &.txb {
            color: #dfcffc; border-color: #dfcffc;
            .iconfont {
              font-size: 28px; margin-top: 3px;
            }
            &:hover {
              background-color: #dfcffc; color: #ffffff;
            }
          }
          &.cjg {
            color: #ffdaa7; border-color: #ffdaa7;
            .iconfont {
              font-size: 30px; margin-top: 2px;
            }
            &:hover {
              background-color: #ffdaa7; color: #ffffff;
            }
          }
          &.zb {
            color: #ffbdbe; border-color: #ffbdbe;
            .iconfont {
              font-size: 26px; margin-top: 3px;
            }
            &:hover {
              background-color: #ffbdbe; color: #ffffff;
            }
          }
        }
      }
    }
  }
}
</style>
